/**
 * Copyright © Veeam Software Group GmbH.
 */

export const TREND_WIDGET_HEIGHT = '366px';
